import { isAfter } from "date-fns";
import { sortDate } from "../utils.js";
export const METERED_VARIABLES = {
    PROGRESSION_INDEX: "progression-index",
    REPLACE_PRODUCT: "replace-product",
    RECEIVED_GIFTS: "received-gifts",
};
export const getMeteredVariableId = ({ subscriptionPlan, identifier, }) => {
    return (subscriptionPlan?.periods
        .find(({ recurring }) => recurring)
        ?.recurring?.meteredVariables?.find((variable) => variable.identifier === identifier)?.id ?? null);
};
export const getLatestMeteredVariable = ({ subscriptionPlan, identifier, usage, period, }) => {
    const id = getMeteredVariableId({ subscriptionPlan, identifier });
    if (!id)
        return null;
    const latestEntry = usage
        .filter(({ meteredVariableId }) => meteredVariableId === id)
        .sort(({ createdAt: a }, { createdAt: b }) => sortDate(a, b))
        .reverse()?.[0] ?? null;
    if (!period || !latestEntry)
        return latestEntry;
    const entryDate = new Date(latestEntry.createdAt);
    const periodStart = new Date(period.start);
    if (isAfter(entryDate, periodStart))
        return latestEntry;
    return null;
};
export const getMeteredVariables = ({ subscriptionPlan, identifier, usage, }) => {
    const id = getMeteredVariableId({ subscriptionPlan, identifier });
    if (!id)
        return null;
    return usage.filter(({ meteredVariableId }) => meteredVariableId === id);
};
export const getProgressionIndex = (usage, plan) => {
    const progressionIndex = getLatestMeteredVariable({
        usage,
        subscriptionPlan: plan,
        identifier: METERED_VARIABLES.PROGRESSION_INDEX,
    });
    return progressionIndex;
};
